import { render, staticRenderFns } from "./column-filters-positions.vue?vue&type=template&id=3f38650c&scoped=true&"
import script from "./column-filters-positions.vue?vue&type=script&lang=js&"
export * from "./column-filters-positions.vue?vue&type=script&lang=js&"
import style0 from "./column-filters-positions.vue?vue&type=style&index=0&id=3f38650c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f38650c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f38650c')) {
      api.createRecord('3f38650c', component.options)
    } else {
      api.reload('3f38650c', component.options)
    }
    module.hot.accept("./column-filters-positions.vue?vue&type=template&id=3f38650c&scoped=true&", function () {
      api.rerender('3f38650c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/positions/data-table/column-filters-positions.vue"
export default component.exports